import { MmRoutesEnum } from './mm-routes.enum';

export const routeToPath = new Map<MmRoutesEnum, string>([
  [MmRoutesEnum.projects, `/${MmRoutesEnum.projects}`],
  [MmRoutesEnum.customers, `/${MmRoutesEnum.customers}`],
  [MmRoutesEnum.projects_overview, `/${MmRoutesEnum.customers}/${MmRoutesEnum.projects_overview}`],
  [MmRoutesEnum.access_denied, `/${MmRoutesEnum.access_denied}`],
  [MmRoutesEnum.faults, `/projects/${MmRoutesEnum.faults}`],
  [MmRoutesEnum.project_informations, `/projects/${MmRoutesEnum.project_informations}`],
  [MmRoutesEnum.project_settings, `/projects/${MmRoutesEnum.project_settings}`],
  [MmRoutesEnum.costs, `/${MmRoutesEnum.costs}`],
  [MmRoutesEnum.costs_invoices, `/${MmRoutesEnum.costs_invoices}`],
  [MmRoutesEnum.costs_timeTracking, `/${MmRoutesEnum.costs_timeTracking}`],
  [MmRoutesEnum.user_variables, `/projects/${MmRoutesEnum.user_variables}`],
  [MmRoutesEnum.capacitor_app_setting, `/projects/${MmRoutesEnum.capacitor_app_setting}`],
  [MmRoutesEnum.project_companies, `/projects/${MmRoutesEnum.project_companies}`],
  [MmRoutesEnum.project_crafts, `/projects/${MmRoutesEnum.project_crafts}`],
  [MmRoutesEnum.project_variables, `/projects/${MmRoutesEnum.project_variables}`],
  [MmRoutesEnum.project_type1, `/projects/${MmRoutesEnum.project_type1}`],
  [MmRoutesEnum.project_type2, `/projects/${MmRoutesEnum.project_type2}`],
  [MmRoutesEnum.co_plans, `/projects/${MmRoutesEnum.co_plans}`],
  [MmRoutesEnum.co_bim_models, `/projects/${MmRoutesEnum.co_bim_models}`],
  [MmRoutesEnum.co_structures, `/projects/${MmRoutesEnum.co_structures}`],
  [MmRoutesEnum.co_bim_sections, `/projects/${MmRoutesEnum.co_bim_sections}`]
]);
